(function () {
  'use strict';

  // Collapsible transcript function
  window.addEventListener('DOMContentLoaded', () => {
    const collapsibleTranscript = document.querySelectorAll('.image-video-container__header');

    //Add a click event handler to collapsible transcript
    collapsibleTranscript.forEach((tab) => {
      tab.addEventListener('click', showTranscript);
    });
  });

  function showTranscript(e) {
    const target = e.target;
    const targetAttribute = target.getAttribute('aria-expanded');
    const transcript = target.nextElementSibling;

    if (targetAttribute == 'false') {
      target.setAttribute('aria-expanded', true);
      transcript.removeAttribute('hidden');
    } else {
      target.setAttribute('aria-expanded', false);
      transcript.setAttribute('hidden', '');
    }
  }
})();
